import _throttle from 'lodash.throttle'

const headerEl = document.querySelector('.c-header');

const storeHeaderHeight = (height) => {
  const box = headerEl.getBoundingClientRect()
  document.documentElement.style.setProperty('--page-header-height', `${box.height}px`)
}

window.addEventListener('resize', _throttle(() => storeHeaderHeight(), 500))
window.addEventListener('DOMContentLoaded', storeHeaderHeight, { once: true })


let scrollObject = {};

const scroll = () => {
  const header = document.querySelector('.c-header');
  const logo = document.querySelector('.c-header__logo');

  if (header) {

    scrollObject = {
      y: window.pageYOffset,
    };
    // If you want to check distance
    if (scrollObject.y > 200) {
      logo.classList.add('c-header__logo--sticky');
    } else {
      logo.classList.remove('c-header__logo--sticky');
    }
  }
};

window.addEventListener('scroll', scroll);
